import React from "react";
import Image from "react-bootstrap/Image";
import styles from "./ModuleThumb.module.scss";
import { Link } from "react-router-dom";

function ModuleThumb(props) {
  return (
    <div
      className={`ratio ratio-1x1 bg-primary rounded smooth cursor-pointer ${styles.moduleThumb}`}
    >
      <h4 className="d-flex justify-content-center align-items-center text-white">
        {props?.title}
      </h4>
      <div className="d-flex h-100">
        {props.image && (
          <Image src={props.image} className={`m-auto ${styles.img}`} />
        )}
      </div>
      {props.url && <Link to={props.url}></Link>}
    </div>
  );
}

export default ModuleThumb;
